export default __webpack_public_path__ + "static/media/logo-cresta.34c83e16.png";